export function setCaretPosition(
  element: HTMLInputElement,
  oldValue: string,
  newValue: string
): void {
  let { selectionEnd } = element;

  let prevPos = selectionEnd || 0;
  let newPos = prevPos;

  if (oldValue.length === prevPos) {
    newPos = newValue.length;
  }

  // to avoid caret jumping when editing value not at the end
  element.value = newValue;

  // set caret position
  element.setSelectionRange(newPos, newPos);
}

export function formatIban(
  iban: string | null | undefined,
  isIBANObfuscated: boolean
): string | null | undefined {
  if (!iban) {
    return iban;
  }

  let cleanedIban = iban
    .replace(/[^a-zA-Z0-9•]/g, '') //!\ in transfer request controller, IBAN are masked with dots
    .toUpperCase()
    .substring(0, 34)
    .replace(/(.{4})/g, `$1 `)
    .trim();

  return isIBANObfuscated ? cleanedIban.replace(/x/gi, '•') : cleanedIban;
}

export function handleFormatIban(element: HTMLInputElement, isIBANObfuscated: boolean): void {
  let { value } = element;
  let newValue = formatIban(value, isIBANObfuscated);
  setCaretPosition(element, value, newValue || '');
}

export function maskInput(
  input: string | null | undefined,
  mask: string = 'X',
  padLeft: number = 4,
  padRight: number = 3
): string | null | undefined {
  if (!input || padLeft + padRight >= input.length) {
    return input;
  }

  input = input.replace(/[^a-zA-Z0-9•]/g, '');

  return `${input.slice(0, padLeft)}${mask.repeat(
    input.length - (padLeft + padRight)
  )}${input.slice(input.length - padRight)}`;
}
